module.exports = __webpack_public_path__ + "static/media/play_icon.d809f8e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play_icon.png
// module id = 1069
// module chunks = 0